import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RetreatCourseRegisterView from './RetreatCourseRegisterView';
import { Creators as registerActions } from '@/domain/useCases/procedures/retreatCourses/registerWithdrawalCourses';
import { Creators as detailActions } from '@/domain/useCases/procedures/getStudentProcedureStatus';
import routes from '@/presentation/components/Routes/routingMap';

const RetreatCourseRegisterViewController = () => {
  const dispatch = useDispatch();
  const [openBack, setOpenBack] = useState(false);
  const history = useHistory();
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const { procedure: procedureSelectedInfo, isLoading } = useSelector(
    (state: any) => state.procedureInformation
  );
  const {
    data: requestIdCreated,
    isLoading: isRegistering,
    isSuccess: isRegistered
  } = useSelector((state: any) => state.registerWithdrawalCourses);

  const relatedCoursesTemp = procedureSelectedInfo?.detail?.relatedCourses
    ? [...procedureSelectedInfo.detail.relatedCourses]
    : [];

  const totalItems = relatedCoursesTemp.concat(
    procedureSelectedInfo?.detail.enrolledCourses
  );

  useEffect(() => {
    if (!isLoading && !procedureSelectedInfo) {
      history.push('/tramites');
    }
  }, [procedureSelectedInfo]);

  const handleOnChange = (item: any) => {
    const isSelected = selectedItems.includes(item);
    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  const handleRegister = () => {
    let individualSelectedCourses: any[] = [];
    selectedItems.map((item: any) => {
      if (item?.courses) {
        individualSelectedCourses = individualSelectedCourses
          .concat(item.courses[0])
          .concat(item.courses[1]);
      } else {
        individualSelectedCourses = individualSelectedCourses.concat(item);
      }
      return '';
    });

    dispatch(
      registerActions.registerWithdrawalCourses(1036, individualSelectedCourses)
    );
  };

  const isDisabled = (item: any) => {
    if (procedureSelectedInfo?.hasFinishedCourses) return false;

    return (
      selectedItems.length >= totalItems.length - 1 &&
      !selectedItems.includes(item)
    );
  };

  useEffect(() => {
    if (requestIdCreated && isRegistered) {
      dispatch(detailActions.getStudentProcedureStatus(1036, requestIdCreated));
      history.push(
        routes.student.procedures.categories.requests.retreatCourse.progress
      );
    }
  }, [requestIdCreated]);

  return (
    <RetreatCourseRegisterView
      procedureSelectedInfo={procedureSelectedInfo}
      totalItems={totalItems}
      open={{
        openBack,
        setOpenBack
      }}
      selectedItems={selectedItems}
      handleOnChange={handleOnChange}
      isDisabled={isDisabled}
      handlerBackButton={handlerBackButton}
      handleRegister={handleRegister}
      isRegistering={isRegistering}
    />
  );
};

export default RetreatCourseRegisterViewController;
